import { VerificationService, StudentPersonalInfoViewModel, logger } from '@sheerid/jslib';

export const getMetadataByKey = (verificationService: VerificationService, metadataKey: string) => {
    const viewModel = verificationService.viewModel as StudentPersonalInfoViewModel;
    const metadata = viewModel ? viewModel.metadata : undefined;
    let metadataValue;
    if (!metadata) {
        logger.warn('No metadata object was found on the viewModel');
        return;
    }
    if (metadata.hasOwnProperty(metadataKey)) {
        metadataValue = metadata[metadataKey] as string;
    }
    return metadataValue;
};

export const getQueryParamsByName = (queryParamName: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.get(queryParamName);
    return queryParam;
};
